// extracted by mini-css-extract-plugin
module.exports = {"qr-overlay":"styles_qr-overlay__eq8ag","ronin-logo-animate":"styles_ronin-logo-animate__gJJ28","ronin-logo-loading":"styles_ronin-logo-loading__e_4dL"};